import CreativeForm from 'common/pages/creative/CreativeForm'

export const CreativeAdvForm = (props) =>
    <CreativeForm {...props} mode={props.mode} agency={false} />